import { Component, OnInit, inject } from "@angular/core";
import { BaseSingleEntityPageComponent } from "../../../shared/base-pages/base-single-entity-page/base-single-entity-page.component";
import { ResourceModel } from "@app/models/rest/resource";
import {
  ChildEntityDeletionBehaviour,
  ChildEntityModel
} from "../../../shared/child-entity-manager/child-entity-model";
import { ResourceSkill } from "@app/models/rest/resource-skill";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { Store } from "@ngrx/store";
import { ResourceSkillStore } from "@app/services/store/resource-skill-store";
import { MatDialog } from "@angular/material/dialog";
import { Skill } from "@app/models/rest/skill";
import { SkillStore } from "@app/services/store/skill-store";
import { ChildEntityDisplayComponent } from "@app/view/shared/child-entity-display/child-entity-display.component";
import { routeAnimations } from "@app/core";
import { SkillResourceAddComponent } from "@app/view/setup/resourcing/resources/skill-resource-add/skill-resource-add.component";
import { MatToolbar } from "@angular/material/toolbar";
import { MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { ResourceSkillMappingForSkillComponent } from "./resource-skill-mapping-for-skill.component";

import { SharedModule } from "@app/view/shared/shared.module";

@Component({
  selector: "app-skill-detail",
  templateUrl: "./skill-detail.component.html",
  styleUrls: ["./skill-detail.component.scss"],
  animations: [routeAnimations],
  standalone: true,
  imports: [
    SharedModule,
    MatToolbar,
    MatIconButton,
    RouterLink,
    MatIcon,
    ResourceSkillMappingForSkillComponent
  ]
})
export class SkillDetailComponent
  extends BaseSingleEntityPageComponent<Skill>
  implements OnInit
{
  skillStore = inject(SkillStore);
  resourceSkillStore = inject(ResourceSkillStore);

  skill: Skill;

  public childEntities: {
    resource: ChildEntityModel<ResourceSkill, Skill>;
  } = { resource: null };

  constructor() {
    super();

    this.childEntities.resource = {
      type: ResourceModel,
      relation: "resource",
      display: "name",
      title: "scheduler.skill-detail.resource.title",
      addComponent: SkillResourceAddComponent,
      displayComponent: ChildEntityDisplayComponent,
      searchKey: "skill",
      readonly: false,
      store: this.resourceSkillStore,
      searchQuery: "findBySkill",
      deletionBehaviour: ChildEntityDeletionBehaviour.LINK_TABLE,
      parentStore: null,
      parentType: null,
      parentRelation: null
    };
  }

  ngOnInit() {
    this.skillStore.entity.subscribe((skill) => {
      this.skill = skill;
    });
    this.detachedMode = false;
    super.loadDataSource(this.skillStore);
  }

  retryLoad() {
    super.retry(this.skillStore);
  }
}
